<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i>样本册表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <template v-if="role_name === '超级权限' || role_name === '软件管理'">
        <el-button v-if="!formStatus && formData.id !== '0'" type="primary" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 编辑</el-button>
        <el-button v-if="formStatus && formData.id !== '0'" type="info" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 取消编辑</el-button>
        <el-button v-if="formStatus" type="primary" size="mini" plain round icon="em-icon-save" @click="handerSave"> 提交保存</el-button>
      </template>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="form-container">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div class="form-main">
          <el-row>
            <el-col :span="4">
              <el-form-item label="样本册" :rules="[{ required: true}]">
                <el-input v-if="formStatus" placeholder="样本册名称" v-model="formData.name"></el-input>
                <span v-else>{{formData.name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="版本年份">
                <el-input v-if="formStatus" placeholder="版本年份" v-model="formData.version_year"></el-input>
                <span v-else>{{formData.version_year}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="册数">
                <el-input-number v-if="formStatus" v-model="formData.book_number" @change="bookNumberhange" controls-position="right" :min="1"></el-input-number>
                <span v-else>{{formData.book_number}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="台纸数量">
                <el-input-number v-if="formStatus" v-model="formData.page_number" controls-position="right" :min="1" @change="handlerPageNumberChange"></el-input-number>
                <span v-else>{{formData.page_number}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="起始页码">
                <el-input-number v-if="formStatus" @change="pageStartChange" v-model="formData.page_no_start" controls-position="right" :min="0"></el-input-number>
                <span v-else>{{formData.page_no_start}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="结束页码">
                <el-input-number v-if="formStatus" @change="pageEndChange" v-model="formData.page_no_end" controls-position="right" :min="1"></el-input-number>
                <span v-else>{{formData.page_no_end}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <el-form-item label="增刷版本">
                <el-input v-if="formStatus" placeholder="增刷版本" v-model="formData.printing_version_number"></el-input>
                <span v-else>{{formData.printing_version_number}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item label="备注">
                <el-input v-if="formStatus" placeholder="备注" v-model="formData.remark"></el-input>
                <span v-else>{{formData.remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div style="height: 28px; padding-top: 5px;">
          <div style="width: 35%; height: 100%; float: left;">
            <div class="detail-header">
              <div class="detail-title"><i class="em-icon-th-list"></i> 样本册组成</div>
              <el-button v-if="formStatus" type="primary" size="mini" icon="el-icon-plus" round @click="handlerShowPartDialog">添加样本册组成</el-button>
            </div>
          </div>
          <div style="border-box; padding:0 5px; width: 45%; height: 100%; float: left;">
            <div class="detail-header">
              <div class="detail-title"><i class="em-icon-th-list"></i> 台号信息 </div>
              <el-button v-if="formStatus" type="primary" size="mini" icon="el-icon-plus" style="float:left" round @click="handlerAddTables">添加台号</el-button>
              <el-upload :action="this.$apis.uploadFiles" class="upload-demo" style="float:left" accept=".xls,.xlsx"
                :on-success="successHandle">
                <el-button v-if="formStatus" size="mini" type="primary" round>上传台号</el-button>
              </el-upload>
            </div>
          </div>
          <div style="width: 20%; height: 100%; float: right;">
            <div class="detail-header">
              <div class="detail-title"><i class="em-icon-th-list"></i> 样本册附件</div>
              <el-upload v-if="formStatus" :action="this.$apis.uploadFiles" multiple :show-file-list='false' :on-success="fileUploadSuccess">
                <el-button type="primary" size="mini" icon="el-icon-upload" round style="float: left;"> 点击上传附件</el-button>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="el-table-container form-details" style="top: 110px;">
          <div style="position: relative; width: 35%; height: 100%; float: left;">
            <el-table :data="formData.details" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row" @selection-change="handlerSelectionChange">
              <el-table-column label="序号" type="index" width="47" align="center"></el-table-column>
              <el-table-column label="部品名称" prop="base_material_name" width="100" align="center"></el-table-column>
              <el-table-column label="单册数量" prop="number" width="60" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="单册数量" class="txtC" v-model="scope.row.number" @change="numberChange(scope.row)"></el-input>
                  <span v-else>{{scope.row.number}}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="总数" prop="total_number" width="40" align="center"></el-table-column> -->
              <el-table-column label="产地" width="100" align="center">
                <template v-slot:default="scope">
                  <el-select v-if="formStatus" clearable filterable size="mini" v-model="scope.row.place_id" placeholder="请选择" @change="placeChange(scope.row)">
                    <el-option v-for="item in placeArr" :key="item.id"  :label="item.name" :value="item.id"></el-option>
                  </el-select>
                  <span v-else>{{scope.row.place_value}}</span>
                </template>
              </el-table-column>
              <el-table-column label="品牌" width="100" align="center">
                <template v-slot:default="scope">
                  <el-select v-if="formStatus" clearable filterable size="mini" v-model="scope.row.brand_id" placeholder="请选择" @change="brandChange(scope.row)">
                    <el-option v-for="item in brandArr" :key="item.id"  :label="item.name" :value="item.id"></el-option>
                  </el-select>
                  <span v-else>{{scope.row.brand_value}}</span>
                </template>
              </el-table-column>
              <el-table-column label="克重" width="100" align="center">
                <template v-slot:default="scope">
                  <el-select v-if="formStatus" clearable filterable size="mini" v-model="scope.row.standard_id" placeholder="请选择" @change="standardChange(scope.row)">
                    <el-option v-for="item in standardArr" :key="item.id"  :label="item.name" :value="item.id"></el-option>
                  </el-select>
                  <span v-else>{{scope.row.standard_value}}</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" prop="remark" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="备注" v-model="scope.row.remark"></el-input>
                  <span v-else>{{scope.row.remark}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="50" align="center">
                <template v-slot:default="scope">
                  <el-button v-if="formStatus" type="danger" size="mini" icon="el-icon-minus" circle @click.stop.prevent="handlerDelDetails(scope.$index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="position: relative; box-size: border-box; padding:0 5px; width: 45%; height: 100%; float: left;">
            <el-table :data="formData.tables" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row" @selection-change="handlerSelectionChange">
              <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
              <el-table-column label="台号" prop="table_number" width="40" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="台号" class="txtC" v-model="scope.row.table_number"></el-input>
                  <span v-else>{{scope.row.table_number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="页码" width="470" align="center">
                <template v-slot:default="scope">
                  <el-select v-if="formStatus" size="mini" v-model="scope.row.page_list" multiple filterable :filter-method="filterValue" @change="pageChange(scope.row)" @focus="focus" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  <span v-else>
                    <span style="display: inline-block; width: 70px; text-align: center; background: #eee; height: 28px; line-height: 28px; margin:0 1px;" v-for="item in scope.row.page_list" :key="item">{{item}}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="每台页数" width="60" align="center">
                <template v-slot:default="scope">
                  <span>{{scope.row.count}}</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" prop="remark" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="备注" v-model="scope.row.remark"></el-input>
                  <span v-else>{{scope.row.remark}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="50" align="center">
                <template v-slot:default="scope">
                  <el-button v-if="formStatus" type="danger" size="mini" icon="el-icon-minus" circle @click.stop.prevent="handlerDelTables(scope.$index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="position: relative; width: 20%; height: 100%; float: right;">
            <el-table :data="formData.attaches" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row" @selection-change="handlerSelectionChange">
              <el-table-column label="序号" type="index" width="47" align="center"></el-table-column>
              <el-table-column label="文件名称" prop="file_name" align="center"></el-table-column>
              <el-table-column label="操作" width="80" align="center">
                <template v-slot:default="scope">
                  <el-button type="success" size="mini" icon="el-icon-download" circle @click.stop.prevent="handlerDownload(scope.row.file_url)"></el-button>
                  <el-button v-if="formStatus" type="danger" size="mini" icon="el-icon-minus" circle @click.stop.prevent="handlerDelAttaches(scope.$index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="form-footer">
          <span>制单人：{{formData.creater_name}}</span>
          <span>制单日期：{{formData.create_time.substring(0,10)}}</span>
        </div>
      </el-form>
    </div>
    <!-- 选择部件对话框 -->
    <ezz-dialog-product-part ref="productPartDialog" width="500px" :parent="this"></ezz-dialog-product-part>
  </el-dialog>
</template>
<style>
.el-tag--mini {
   width: 90px;
}
.el-tag--mini .el-icon-close {
  float: right;
  margin-top: 1px;
}
</style>
<script>
import EzzDialogProductPart from '@/views/modules/product/DialogPart.vue'
import XLSX from 'xlsx'
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      formEmptyData: {
        id: '0',
        category_id: '0',
        code: '',
        name: '',
        version_year: '',
        printing_version_number: '0',
        book_number: '',
        page_number: '',
        page_no_start: '',
        page_no_end: '',
        remark: '',
        details: [],
        attaches: [],
        tables: [],
        creater_name: sessionStorage.getItem('operator'),
        creater_id: sessionStorage.getItem('operator_id'),
        create_time: ''
      },
      formDetailEmptyData: {
        id: '',
        product_id: '',
        base_material_id: '',
        base_material_name: '',
        place_id: '',
        place_value: '',
        brand_id: '',
        brand_value: '',
        standard_id: '',
        standard_value: '',
        number: '1',
        total_number: '',
        remark: ''
      },
      formAttachesEmptyData: {
        id: '',
        product_id: '',
        raw_file_name: '',
        file_name: '',
        file_url: '',
        file_txt: '',
        sort: '',
        remark: ''
      },
      formTableEmptyData: {
        id: '',
        product_id: '',
        table_number: '',
        page_list: '',
        count: '',
        remark: ''
      },
      operator_id: sessionStorage.getItem('operator_id'),
      formStatus: false,
      editable: this.$store.state.editable,
      delable: this.$store.state.delable,
      currentVal: '',
      options: [],
      optionsCopy: [],
      placeArr: [],
      brandArr: [],
      standardArr: [],
      pageArr: [],
      role_name: sessionStorage.getItem('role_name')
    }
  },
  beforeCreate: function () {
    var date = new Date()
    var month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
    this.currentDate = date.getFullYear() + '-' + month + '-' + day
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    pageChange: function (item) {
      item.count = item.page_list.length
    },
    setInitValue: function () {
      this.options = []
      this.optionsCopy = []
      for (let i = 0; i < this.pageArr.length; i++) {
        this.options.push({ 'value': this.pageArr[i].name.toString(), 'label': this.pageArr[i].name.toString() })
        this.optionsCopy.push({ 'value': this.pageArr[i].name.toString(), 'label': this.pageArr[i].name.toString() })
      }
    },
    pageStartChange: function (e) {
      this.formData.page_no_end = (e + this.formData.page_number * 2 - 1).toString()
      this.setInitValue()
    },
    pageEndChange: function (currentValue, oldValue) {
      if (currentValue - this.formData.page_number * 2 + 1 < 0) {
        this.$message({
          type: 'warning',
          message: '结束页码过小，请重新输入'
        })
        this.formData.page_no_end = (oldValue).toString()
        return false
      } else {
        this.formData.page_no_start = (currentValue - this.formData.page_number * 2 + 1).toString()
      }
      this.setInitValue()
    },
    // 搜索过滤方法
    filterValue (currentVal) {
      if (currentVal.length > 0) {
        this.options = this.optionsCopy.filter(item => {
          if (currentVal === item.label.substring(0, currentVal.length)) {
            return true
          }
        })
        this.currentVal = currentVal
      } else {
        this.options = this.optionsCopy
        this.currentVal = ''
      }
    },
    // 聚焦时
    focus () {
      if (this.currentVal.length > 0) {
        this.options = this.optionsCopy.filter(item => {
          if (this.currentVal === item.label.substring(0, this.currentVal.length)) {
            return true
          }
        })
        return false
      } else {
        this.options = this.optionsCopy
      }
      if (this.currentVal) {
        this.options = this.optionsCopy
      }
    },
    // 加载数据
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getProduct, { ModelId: _this.formData.id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          _this.placeArr = _json.place
          _this.brandArr = _json.brand
          _this.standardArr = _json.standard
          _this.pageArr = _json.pages
          _this.setInitValue()
          if (_json.formData != null) {
            _this.formData = _json.formData
            for (let i = 0; i < _this.formData.details.length; i++) {
              if (_this.formData.details[i].place_id === '0') {
                _this.formData.details[i].place_id = ''
              }
              if (_this.formData.details[i].brand_id === '0') {
                _this.formData.details[i].brand_id = ''
              }
              if (_this.formData.details[i].standard_id === '0') {
                _this.formData.details[i].standard_id = ''
              }
            }
            // select字符串转数组
            for (let i = 0; i < _this.formData.tables.length; i++) {
              let selectArray = []
              if (_this.formData.tables[i].page_list !== '') {
                selectArray = _this.formData.tables[i].page_list.split(',')
              }
              _this.formData.tables[i].page_list = selectArray
            }
          } else {
            _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
            const date = new Date()
            _this.formData.category_id = _this.parent.currentCategory.id
            _this.formData.version_year = date.getFullYear().toString()
            _this.formData.creater_id = _this.operator_id
            _this.formData.create_time = _this.currentDate
          }
        }
      })
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    // 产地改变事件
    placeChange: function (item) {
      let resultArr = this.placeArr.filter((l) => { return l.id === item.place_id })
      item.place_value = resultArr[0].name
    },
    // 品牌改变事件
    brandChange: function (item) {
      let resultArr = this.brandArr.filter((l) => { return l.id === item.brand_id })
      item.brand_value = resultArr[0].name
    },
    // 克重改变事件
    standardChange: function (item) {
      let resultArr = this.standardArr.filter((l) => { return l.id === item.standard_id })
      item.standard_value = resultArr[0].name
    },
    bookNumberhange: function (e) {
      for (let i = 0; i < this.formData.details.length; i++) {
        this.formData.details[i].total_number = (this.formData.details[i].number * e).toString()
      }
    },
    numberChange: function (_row) {
      _row.total_number = (this.formData.book_number * _row.number).toString()
    },
    handlerAdd: function () {
      this.formData.id = '0'
      this.loadData()
      this.isShow = true
      this.formStatus = true
    },
    handlerView: function (formId) {
      this.formData.id = formId
      this.loadData()
      this.isShow = true
      this.formStatus = false
    },
    handlerPageNumberChange: function (currentValue, oldValue) {
      if (currentValue === 1) {
        this.formData.page_no_start = '0'
        this.formData.page_no_end = '1'
      } else {
        this.formData.page_no_start = '1'
        this.formData.page_no_end = (currentValue * 2).toString()
      }
      this.setInitValue()
    },
    // 打开明细中对应人选择对话框
    handlerShowPartDialog: function () {
      this.$refs.productPartDialog.open()
    },
    handlerAddTables: function () {
      const newTable = JSON.parse(JSON.stringify(this.formTableEmptyData))
      const length = this.formData.tables.length
      newTable.table_number = (length + 1).toString()
      this.formData.tables.push(newTable)
    },
    successHandle: function (response, file, fileList) {
      if (/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
        this.readExcel(file.raw)
      } else {
        this.$message({
          type: 'error',
          message: '只能上传.xls和.xlsx文件'
        })
      }
    },
    readExcel (file) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onloadend = ev => {
        try {
          this.$forceUpdate()
          const data = ev.target.result
          const workbook = XLSX.read(data, {
            type: 'binary',
            cellDates: true
          })
          const wsname = workbook.SheetNames[0]
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname])
          // const header = _this.get_header_row(workbook.Sheets[wsname])
          _this.formData.tables = []
          for (let i = 0; i < ws.length; i++) {
            const newTable = { id: '', product_id: '', table_number: '', page_list: [], count: '', remark: '' }
            if (_this.formData.tables.length === 0) {
              newTable.table_number = ws[i].台号
              newTable.page_list.push(ws[i].页码)
              newTable.count = 1
              _this.formData.tables.push(newTable)
            } else {
              if (_this.formData.tables[_this.formData.tables.length - 1].table_number === ws[i].台号) {
                _this.formData.tables[_this.formData.tables.length - 1].page_list.push(ws[i].页码)
                _this.formData.tables[_this.formData.tables.length - 1].count = _this.formData.tables[_this.formData.tables.length - 1].page_list.length
              } else {
                newTable.table_number = ws[i].台号
                newTable.page_list.push(ws[i].页码)
                newTable.count = 1
                _this.formData.tables.push(newTable)
              }
            }
          }
          _this.$message({
            type: 'success',
            message: '上传成功!'
          })
        } catch (e) {
          _this.$message({
            type: 'error',
            message: '上传失败!'
          })
        }
      }
      fileReader.readAsBinaryString(file)
    },
    get_header_row (sheet) {
      const headers = []
      /* sheet['!ref']表示所有单元格的范围，例如从A1到F8则记录为 A1:F8 */
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C; let R = range.s.r /* 从第一行开始 */
      /* 按列进行数据遍历 */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* 查找第一行中的单元格 */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]

        let hdr = 'UNKNOWN ' + C // <-- 进行默认值设置
        if (cell && cell.t) { hdr = XLSX.utils.format_cell(cell) }

        headers.push(hdr)
      }
      return headers
    },
    handlerDelDetails: function (_index) {
      const _this = this
      _this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$delete(_this.formData.details, _index)
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handlerDelAttaches: function (_index) {
      const _this = this
      _this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$delete(_this.formData.attaches, _index)
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handlerDelTables: function (_index) {
      const _this = this
      _this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$delete(_this.formData.tables, _index)
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handlerDownload: function (_fileUrl) {
      window.open(this.$apiroot + _fileUrl)
    },
    handlerSelectionChange: function (_selection) {
      this.selectedContacters = _selection
    },
    // 表单验证，_mainData是主表数据，_detailData从表数据，如果只验证从表数据，_mainData要设置为null
    validationHandler: function (_mainData) {
      let _this = this
      if (_mainData !== null) {
        if (_mainData.name === '') {
          _this.$message({
            type: 'error',
            message: '样本册名称不能为空'
          })
          return false
        }

        if (_mainData.details.length === 0) {
          _this.$message({
            type: 'error',
            message: '样本册组成明细不能为空'
          })
          return false
        }
        /*
        if (_mainData.tables.length === 0) {
          _this.$message({
            type: 'error',
            message: '台号信息明细不能为空'
          })
          return false
        }
        */
      }
      return true
    },
    // 新增时主从表同时保存
    handerSave: function () {
      let _this = this
      if (_this.validationHandler(_this.formData)) {
        _this.formData.operator_id = _this.operator_id
        // select数组转字符串
        for (var i = 0; i < _this.formData.tables.length; i++) {
          let selectArray = []
          for (var j = 0; j < _this.formData.tables[i].page_list.length; j++) {
            selectArray.push(_this.formData.tables[i].page_list[j])
          }
          _this.formData.tables[i].page_list = selectArray.join()
        }
        _this.post(_this.$apis.saveProduct, _this.formData, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            if (_json.status === 'ok') {
              _this.$message({
                message: '保存成功',
                type: 'success'
              })
              _this.formData.id = _json.id
              _this.formStatus = false
              // select字符串转数组
              for (var i = 0; i < _this.formData.tables.length; i++) {
                let selectArray = []
                if (_this.formData.tables[i].page_list !== '') {
                  selectArray = _this.formData.tables[i].page_list.split(',')
                }
                _this.formData.tables[i].page_list = selectArray
              }
              _this.parent.loadData()
            } else {
              if (_json.status === 'hasProduct') {
                _this.$message({
                  message: '该产品已经存在',
                  type: 'warning'
                })
              } else {
                _this.$message({
                  message: '操作失败',
                  type: 'danger'
                })
              }
            }
          }
        })
      }
    },
    // 上传插件附件
    fileUploadSuccess: function (res) {
      let _this = this
      let _status = res.status
      if (_status === 'ok') {
        let _fileInfo = res.fileInfo
        let _newFile = JSON.parse(JSON.stringify(this.formAttachesEmptyData))

        _newFile.raw_file_name = _fileInfo.raw_file_name
        _newFile.file_name = _fileInfo.file_name
        _newFile.file_type = _fileInfo.file_type
        _newFile.file_url = _fileInfo.file_url
        _newFile.file_size = _fileInfo.file_size

        _this.formData.attaches.push(_newFile)
      }
    }
  },
  components: {
    EzzDialogProductPart
  }
}
</script>
